import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { Tags } from 'lucide-react';
import { ComplaintBrands } from './ComplaintBrands';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/complaints/brands')({
    staticData: {
        metadata: {
            title: 'Brands',
        },
        ui: {
            icon: Tags,
            title: 'Complaint brands',
            subtitle: 'Brand options shown on internal and external lodgement forms',
            menuDescription: 'Brand options shown on internal and external lodgement forms',
        },
    },
    component: ComplaintBrandsTab,
});

function ComplaintBrandsTab() {
    return (
        <PageController route={Route}>
            <ComplaintBrands />
        </PageController>
    );
}
